<template>
  <div>
    <h1 class="title is-2">Links de facturación</h1>
    <p class="subtitle is-5">Elige una opción</p>
    <div class="columns" align="center">
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/koreanair/pasaje/search.htm"
        >
          <img alt="imagenicon" src="@/assets/KoreanA.png" />
        </a>
      </div>
      <div class="column card-header">
        <a href="https://www.alitalia.com/es_mx/special-pages/invoice.html">
          <img alt="imagenicon" src="@/assets/ItaA.png" />
        </a>
      </div>
      <div class="column card-header">
        <a href="https://argentinasmx.getyourinvoice.com/airline/AR"
          ><img alt="imagenicon" src="@/assets/aa.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://eticketinvoice.avianca.com/invoice?lang=es"
          ><img alt="imagenicon" src="@/assets/avianca.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://amfacturacion.aeromexico.com/?_ga=2.233478487.833301484.1618497521-401859891.1599154058"
          ><img alt="imagenicon" src="@/assets/aeromexico.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://alaskaairlines.getyourinvoice.com/airline/AS"
          ><img alt="imagenicon" src="@/assets/Alaska.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://airlines.e-facturate.com/invoiceaa/"
          ><img alt="imagenicon" src="@/assets/American.png"
        /></a>
      </div>
    </div>

    <div class="columns" align="center">
      <div class="column card-header">
        <a
          href="mailto:qatarairwaysfacturacion@mex.auren.com?Subject=Solicitud de factura"
        >
          <img alt="imagenicon" src="@/assets/Qatar.png" />
        </a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/aireuropa/pasaje/search.htm#!#collapse1"
        >
          <img alt="imagenicon" src="@/assets/AIRE.png" />
        </a>
      </div>
      <div class="column card-header">
        <a href="https://aircanada.getyourinvoice.com/airline/AC"
          ><img alt="imagenicon" src="@/assets/Air.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://copamx.getyourinvoice.com/airline/CO"
          ><img alt="imagenicon" src="@/assets/Copa.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/delta/pasaje/search.htm"
          ><img alt="imagenicon" src="@/assets/delta.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://airfrancemx.getyourinvoice.com/airline/af"
          ><img alt="imagenicon" src="@/assets/AirF.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://klmmx.getyourinvoice.com/airline/kl"
          ><img alt="imagenicon" src="@/assets/KLM.png"
        /></a>
      </div>
    </div>

    <div class="columns" align="center">
      <div class="column card-header">
        <a
          href="https://receipts.flytap.com/PaxReceiptsWAR/spring/docs?locale=en"
        >
          <img alt="imagenicon" src="@/assets/TapA.png" />
        </a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/lufthansa/pasaje/search.htm"
          ><img alt="imagenicon" src="@/assets/Lufthansa.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/hahnair/es/consulta-ticket-cfdi-hahnair.html"
          ><img alt="imagenicon" src="@/assets/HR.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://www.iberia.com/mx/facturas/"
          ><img alt="imagenicon" src="@/assets/iberia.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/allnipponairways/search.htm"
          ><img alt="imagenicon" src="@/assets/ana.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/united/pasaje/search.htm"
          ><img alt="imagenicon" src="@/assets/United.png"
        /></a>
      </div>
    </div>

    <div class="columns" align="center">
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/airnewzealand/search.htm"
        >
          <img alt="imagenicon" src="@/assets/AirN.png" />
        </a>
      </div>
      <div class="column card-header">
        <a href="https://hola.jetblue.com/request-receipt#/"
          ><img alt="imagenicon" src="@/assets/JetBlue.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://facturacion.vivaaerobus.com/"
          ><img alt="imagenicon" src="@/assets/aerobus.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://factura.volaris.com/"
          ><img alt="imagenicon" src="@/assets/volaris.png"
        /></a>
      </div>
      <div class="column card-header">
        <a href="https://tarmexico.com/#/invoice"
          ><img alt="imagenicon" src="@/assets/tar.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/latam/pasaje/search.htm"
          ><img alt="imagenicon" src="@/assets/Latam.png"
        /></a>
      </div>
    </div>
    <div class="columns" align="center">
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/cathaypacific/pasaje/search.htm"
        >
          <img alt="imagenicon" src="@/assets/CatP.png" />
        </a>
      </div>
      <div class="column card-header">
        <a href="https://facturacion.aeromar.com.mx/pax"
          ><img alt="imagenicon" src="@/assets/aeromar.png"
        /></a>
      </div>
      <div class="column card-header">
        <a
          href="https://webportal.edicomgroup.com/customers/airtransat/pasaje/search.htm"
          ><img alt="imagenicon" src="@/assets/Transat.png"
        /></a>
      </div>

      <div class="column card-header">
        <a href="https://ba.digitalinvoice.travel/PortalBA">
          <img alt="imagenicon" src="@/assets/BritishA.png" />
        </a>
      </div>
      <div class="column card-header" @click="navegarHacia('Turkish')">
        <img alt="imagenicon" src="@/assets/turkish.png" />
      </div>
      <div class="column card-header" @click="navegarHacia('Emirates')">
        <img alt="imagenicon" src="@/assets/emirates.png" />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus";
export default {
  name: "Inicio",
  data: () => ({}),
  mounted() {},
  methods: {
    navegarHacia(nombreRuta) {
      EventBus.$emit("navegarHacia", nombreRuta);
    },
  },
};
</script>
